// Non-cryptographic fallback for runtimes that predate crypto.randomUUID
export const newIdempotencyKey = () =>
  globalThis.crypto?.randomUUID?.() ??
  `${Date.now()}-${Math.random().toString(16).slice(2)}`;
